//@ts-nocheck
/* eslint-disable react/prefer-stateless-function */
import React from 'react'
import ConfigurationContext from '../contexts/ConfigurationContext'
import hoistNonReactStatics from 'hoist-non-react-statics'
import forwardInnerRef from './forwardInnerRef'

const defaultConfigutation = {
  stargateUrl: 'https://stargate.wework.com',
  spacestationBaseUrl: 'https://spacestation-staging.wework.com/#/',
  spacemanToken: null,
  appId: null,
  appSecret: null,
  baseUrl: null,
}

const withConfiguration = () => {
  return Component => {
    // eslint-disable-next-line react/require-render-return
    class WrappedComponent extends React.Component {
      render() {
        return (
          <ConfigurationContext.Consumer>
            {configuration => {
              const mergedConfiguration = {
                ...defaultConfigutation,
                ...configuration,
              }
              return (
                <Component
                  {...this.props}
                  configuration={mergedConfiguration}
                />
              )
            }}
          </ConfigurationContext.Consumer>
        )
      }
    }

    WrappedComponent.displayName = `RFWithConfiguration(${Component.displayName})`
    hoistNonReactStatics(WrappedComponent, Component)

    return forwardInnerRef(WrappedComponent)
  }
}

export default withConfiguration
